export default function GraphItemFilled({ color }: { color: string }) {
  return <div className="bar-filled" style={{ backgroundColor: color }}></div>
}
